import * as attribution from './lib';
window.attribution = attribution;
export default attribution;